export default __webpack_public_path__ + "static/media/svg-1.e77ab645.svg";